export default "/assets/images/mila-box.png?b584e2d2a3d8d2a4ff10f556f693ce30";